import * as React from 'react';
import HelpOutlineIcon from '../Icons/HelpOutlineIcon';
import { IOriginIconProps } from '../OriginIcon';
import PhoneIcon from '../Icons/PhoneIcon';
import BuildIcon from '../Icons/BuildIcon';
import FlatRoofIcon from '../Icons/FlatRoofIcon';
import PitchedRoofIcon from '../Icons/PitchedRoofIcon';
import HomeIcon from '../Icons/HomeIcon';
import CloseIcon from '../Icons/CloseIcon';

export interface SolarIconProps extends IOriginIconProps {
  iconType: string;
}

export const SolarIcon: React.StatelessComponent<SolarIconProps> = (props: SolarIconProps) => {
  const { iconType, ...other } = props;
  switch (iconType) {
    case 'phone':
      return <PhoneIcon {...other} />;
    case 'helpOutline':
      return <HelpOutlineIcon {...other} />;
    case 'build':
      return <BuildIcon {...other} />;
    case 'flatRoof':
      return <FlatRoofIcon {...other} />;
    case 'pitchedRoof':
      return <PitchedRoofIcon {...other} />;
    case 'home':
      return <HomeIcon {...other} />;
    case 'close':
      return <CloseIcon {...other} />;
    default:
      return null;
  }
};
